import { Select } from '@material-ui/core';
import React, { useState } from 'react';

const SelectLetter = () => {
  const [selectedOption, setSelectedOption] = useState('');

  const handleSelectChange = (event) => {
    setSelectedOption(event.target.value);
  };

  return (
    <div>
      <Select
        style={{ width: '100px' }}
        id="selectExample"
        value={selectedOption}
        onChange={handleSelectChange}
      >
        <option value="option1">10</option>
        <option value="option2"> 9</option>
        <option value="option3"> 8</option>
        <option value="option4"> 7</option>
        <option value="option5">6</option>
        <option value="option6">5</option>
        <option value="option7">4</option>
        <option value="option8">0</option>
        <option value="option9">N.A</option>
      </Select>
    </div>
  );
};

export default SelectLetter;
